<template>
  <div>
    <agent-mch-apply-drawer :visible="showAgentMchApplyDrawer" 
      :agentId="agentId" @close-drawer="showAgentMchApplyDrawer = false" />
  </div>
</template>

<script>
import AgentMchApplyDrawer from './components/AgentMchApplyDrawer.vue'
export default {
    name: 'AgentList',

    components: {
      'agent-mch-apply-drawer': AgentMchApplyDrawer,
    },

    data() {
        return {
          showAgentMchApplyDrawer: false,
          agentId: '',
        }
    },

    methods: {
      initData() {
        this.$prompt('请输入代理id', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^\d+$/,
          inputErrorMessage: '请输入正确的代理id'
        }).then(({ value }) => {
          this.agentId = value;
          this.showAgentMchApplyDrawer = true;
        })
      }
    },

    mounted() {
      this.$emit("breadcrumb", {text1: "用户管理", text2: "代理"});
      this.initData();
    },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/usermng/AgentList.vue